export function AccordionApp(firstAccordionId) {
  return {
    openedAccordions: [],
    isAccordionOpened(blockId) {
      return this.openedAccordions.includes(blockId);
    },
    toggleAccordion(blockId) {
      if (this.isAccordionOpened(blockId)) {
        this.openedAccordions.splice(this.openedAccordions.indexOf(blockId), 1);
      } else {
        this.openedAccordions.push(blockId);
      }
    },
    mounted() {
      if (firstAccordionId) {
        this.toggleAccordion(firstAccordionId);
      }
    },
  };
}
